import React from 'react';

import {Icon, NavItem} from '@albert-io/atomic';
import {Link} from 'react-router';
import useNavItems from '../useNavItems';

const MainNavItems = () => {
  const {getIsMatchingRoute, mainNavItems} = useNavItems();

  return (
    <nav className='global-nav__main' aria-label='main'>
      <ul className='global-nav__main-list'>
        {mainNavItems.map((navItem) => {
          const {hardLink = false, icon, key, name, route} = navItem;

          const isMatchingRoute = getIsMatchingRoute(navItem);
          const props = {
            [hardLink ? 'href' : 'to']: route
          };
          const LinkElement = hardLink ? 'a' : Link;

          return (
            <li key={key}>
              {/* @ts-ignore */}
              <NavItem {...props} as={LinkElement} active={isMatchingRoute} className='gap-x1 flex'>
                {icon !== undefined && <Icon icon={icon} />}
                {name}
              </NavItem>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MainNavItems;
